import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ButtonModule } from "primeng/button";;
import { InputTextModule } from "primeng/inputtext";
import { TableModule } from 'primeng/table';
import { HttpClientModule } from "@angular/common/http";
import { DividerModule } from "primeng/divider";
import { ConfirmationService } from "primeng/api";
import { FormsModule } from "@angular/forms";
import { MessagesModule } from "primeng/messages";
import { DropdownModule } from "primeng/dropdown";
import { InputSwitchModule } from "primeng/inputswitch";
import { ItemServicoEditarComponent } from "./item-servico-editar.component";
import { ItemServicoEditarRoutingModule } from "./item-servico-editar-routing.module";
import { InputNumberModule } from "primeng/inputnumber";
import { InputMaskModule } from "primeng/inputmask";
import { DialogModule } from "primeng/dialog";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { TooltipModule } from "primeng/tooltip";
import { ConfirmDialogModule } from "primeng/confirmdialog";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ItemServicoEditarRoutingModule,
        ButtonModule,
        InputTextModule,
        TableModule,
        HttpClientModule,   
        DividerModule,
        MessagesModule,
        DropdownModule,
        InputSwitchModule,
        InputNumberModule,
        InputMaskModule,
        DialogModule,
        TooltipModule,
        ConfirmDialogModule,
        ProgressSpinnerModule
    ],
    providers: [ConfirmationService],
    declarations: [ItemServicoEditarComponent]
})
export class ItemServicoEditarModule { }
